export default __webpack_public_path__ + "static/media/package-2.f46a7289.svg";